import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export enum ID_GENDERS {
  MASCHIO = 'M',
  FEMMINA = 'F',
  SCONOSCIUTO = 'N',
}

export const genders = Object.freeze([
  {
    id: ID_GENDERS.MASCHIO,
    value: 'Maschile',
  },
  {
    id: ID_GENDERS.FEMMINA,
    value: 'Femminile',
  },
  {
    id: ID_GENDERS.SCONOSCIUTO,
    value: 'Neutro',
  },
]);

interface ListGenderProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  isSmallSize?: boolean;
  withoutUnknown?: boolean;
  label?: string;
}

const ListGenderComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
  withoutUnknown = false,
  label = 'Sesso',
}: ListGenderProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="gender-label">
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId="gender-label"
        id="gender"
        name="gender"
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {genders
          .filter((item) => !(withoutUnknown && item.id === ID_GENDERS.SCONOSCIUTO))
          .map((gender: ItemVM) => (
            <MenuItem key={gender.id} value={gender.id}>
              {gender.value}
            </MenuItem>
          ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListGenderComponent.displayName = 'List Gender component';

const ListGender = memo(ListGenderComponent);

export default ListGender as typeof ListGenderComponent;
